import { useEffect, useContext, useState } from 'react';
import { Button, Modal, Select } from 'semantic-ui-react';
import { store } from '../store';
import { SET_REFERENCE_COLORS, SET_SHOW_LOAD_MODAL } from '../types';

const SaveModal = () => {
  const { showLoadModal, dispatch } = useContext(store);
  const [name, setName] = useState('');
  const [paletteNames, setPaletteNames] = useState([]);

  useEffect(() => {
    const appData = JSON.parse(localStorage.getItem('photoReference'));
    if (appData) {
      const paletteNamesFromStorage = Object.keys(appData).map((palette) => ({
        value: palette,
        text: palette,
        key: palette,
      }));
      setPaletteNames(paletteNamesFromStorage);
    }
  }, []);

  const handlePaletteChange = (e, selectedPalette) =>
    setName(selectedPalette.value);

  const close = () => dispatch({ type: SET_SHOW_LOAD_MODAL, payload: false });

  const setData = () => {
    const appData = JSON.parse(localStorage.getItem('photoReference'));
    const colors = appData[name];
    dispatch({ type: SET_REFERENCE_COLORS, payload: colors });
    close();
  };

  return (
    <Modal size="mini" open={showLoadModal} onClose={close}>
      <Modal.Header>Load Saved Palette</Modal.Header>
      <Modal.Content>
        <p>Would you like to load a previously saved palette?</p>
        <Select
          options={paletteNames}
          placeholder="Palette Name"
          search
          fluid
          value={name}
          onChange={handlePaletteChange}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>No</Button>
        <Button positive disabled={!name} onClick={setData}>
          Load Data
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default SaveModal;
